<!--
 * @Author: wsx
 * @Date: 2022-01-11 09:54:13
 * @LastEditTime: 2022-06-15 18:03:21
 * @LastEditors: zhangyaowen zhangyaowen_520@163.com
 * @Description:穿梭框
-->
<template>
  <div id="HTransfer" class="HTransfer">
    <el-card class="h-transfer-panel">
      <template #header>
        <div class="card-header">
          <el-checkbox
            v-model="checked1"
            @change="handleTreeCheckAllChange"
            :indeterminate="isTreeIndeterminate"
            size="large"
          >
          </el-checkbox>

          <span class="title">{{ titles[0] || "List 1" }}</span>
        </div>
      </template>
      <div class="h-transfer-panel__body">
        <el-input
          v-model="filterText"
          placeholder="请输入关键词"
          class="h-transfer-panel__filter"
        >
          <template #prefix>
            <i class="iconfont icon-31sousuo"></i>
          </template>
        </el-input>
        <div class="h-transfer-panel__list" style="height: 100px">
          <el-tree-v2
            class="h-transfer-panel__tree"
            ref="treeRef"
            :data="data"
            :height="270"
            show-checkbox
            :props="{ value: valueText, label: labelText, children: chilText }"
            :default-expanded-keys="defaultExpandedKeys"
            :expand-on-click-node="true"
            :filter-node-method="filterNode"
            @check-change="handleCheckChange"
            @node-click="handleNodeClick"
          >
            <template #default="{ data }" v-if="showDefineTree">
              <span
                class="camera-icon"
                :style="{
                  color:
                    data.deviceLineStatus == '0'
                      ? '#12e9f8'
                      : data.deviceLineStatus == '1'
                      ? '#dddddd'
                      : '#f55252',
                }"
              >
                <h-icon v-if="data.cameraId" icon="icon-shexiangtou" />
              </span>
              <span>{{ data[labelText] }}</span>
            </template>
          </el-tree-v2>
        </div>
      </div>
    </el-card>
    <div class="h-transfer__buttons">
      <h-button
        type="primary"
        @click="addData"
        position="right"
        icon="icon-xiangyoujiantou"
        >{{ buttonTexts[0] || "移入" }}</h-button
      >
      <h-button type="primary" @click="delData" icon="icon-xiangzuojiantou">{{
        buttonTexts[1] || 移除
      }}</h-button>
    </div>
    <el-card class="h-transfer-panel">
      <template #header>
        <div class="card-header">
          <el-checkbox
            v-model="checked2"
            :indeterminate="isIndeterminate"
            @change="handleCheckAllChange"
            size="large"
          />
          <div class="typeStyle" v-if="showEquipmentType">
            <span>设备类型：</span>
            <el-select
              v-model="selectValue"
              placeholder="请选择"
              style="width: 50%"
              clearable
            >
              <el-option
                v-for="item in selectTypeList"
                :key="item.code"
                :label="item.value"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <span class="title">{{ titles[1] || "List 2" }}</span>
        </div>
      </template>
      <div class="h-transfer-panel__body">
        <el-input
          v-model="filterCheck"
          placeholder="请输入关键词"
          class="h-transfer-panel__filter"
        >
          <template #prefix>
            <i class="iconfont icon-31sousuo"></i>
          </template>
        </el-input>
        <div class="h-transfer-panel__list">
          <el-checkbox-group
            class="h-transfer-panel__group"
            v-model="checkList"
            @change="handleCheckedCitiesChange"
          >
            <template v-for="item in selectedList" :key="item[nodeKey]">
              <div class="selectedList">
                <el-checkbox :label="item[nodeKey]">
                  {{ item[labelText] }}
                </el-checkbox>
                <el-select
                  v-model="item.cameraInOutType"
                  placeholder="请选择"
                  size="small"
                  style="width: 30%"
                  v-if="showEquipmentType"
                  clearable
                >
                  <el-option
                    v-for="item in selectTypeList"
                    :key="item.code"
                    :label="item.value"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
          </el-checkbox-group>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs,
  watch,
  ref,
  nextTick,
  computed,
} from "vue";
import _ from "lodash";
// import virtualList from "vue-virtual-scroll-list";
// import transferItem from "./transferItem.vue";
import { getDict } from "@/api/constant";
export default defineComponent({
  name: "HTransfer",
  components: {},
  props: {
    titles: {
      type: Array,
      default: () => ["List 1", "List 2"],
    },
    buttonTexts: {
      type: Array,
      default: () => ["添加", "删除"],
    },
    data: {
      type: Array,
      default: () => [],
    },
    nodeKey: {
      type: String,
      default: "id",
    },
    checkedKey: {
      type: String,
      default: "id",
    },
    defaultExpandedKeys: {
      type: Array,
      default: () => [],
    },
    areaCameraArry: {
      type: Array,
      default: () => [],
    },
    showDefineTree: {
      type: Boolean,
      default: false,
    },
    showEquipmentType: {
      type: Boolean,
      default: false,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    props: {
      type: Object,
      default: () => {
        return {
          value: "id",
          label: "label",
          children: "children",
        };
      },
    },
  },
  emits: ["update:modelValue", "nodeClick"],
  setup(props, context) {
    const state = reactive({
      checked1: false,
      checked2: false,
      valueText: props.props.value || "id",
      labelText: props.props.label || "label",
      chilText: props.props.children || "children",
      filterText: "",
      filterCheck: "",
      selectedList: [],
      sourceList: [],
      checkList: [],
      isTreeIndeterminate: false,
      cloenAreaCamera: [], // 接口穿过来的已绑定设备
      selectTypeList: [],
      showEquipmentType: props.showEquipmentType, // 为true时专为区域管理使用
      selectValue: "0",
    });
    const refData = toRefs(state);
    const treeRef = ref(null);
    const isIndeterminate = ref(false);
    watch(
      () => state.filterText,
      (v) => {
        console.log(state.filterText);
        treeRef.value && treeRef.value.filter(v);
        // nextTick(() => {
        //   filterNode();
        // });
      }
    );
    watch(
      () => state.filterCheck,
      (v) => {
        const list = state.sourceList.filter((item) => {
          return item[state.labelText].includes(v);
        });
        _.cloneDeep(list);
        state.selectedList = list;
      }
    );
    watch(
      () => state.selectedList,
      (v) => {
        context.emit("update:modelValue", v);
      }
    );
    watch(
      () => state.selectValue,
      (v) => {
        state.selectedList.forEach((item) => {
          state.checkList.forEach((el) => {
            if (el == item.cameraId) {
              item.cameraInOutType = state.selectValue;
            }
          });
        });
      }
    );
    // 对树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      console.log();
      return data[state.labelText].includes(value);
      // return data[state.labelText].indexOf(value) !== -1;
    };
    // 当复选框被点击的时候触发
    const handleCheckChange = () => {
      const keys = treeRef.value.getHalfCheckedKeys();
      if (keys.length > 0) {
        state.isTreeIndeterminate = true;
      } else {
        const keys = treeRef.value.getCheckedKeys();
        state.checked1 = keys.length > 0;
        state.isTreeIndeterminate = false;
      }
    };
    const handleNodeClick = (node) => {
      context.emit("nodeClick", node);
    };
    // 自动添加已有设备
    const handleSetChecked = () => {
      treeRef.value.setCheckedKeys(props.areaCameraArry);
    };
    // 移除数据
    const delData = () => {
      state.selectedList = state.selectedList.filter(
        (item) => !state.checkList.includes(item[props.nodeKey])
      );
      const newCheckedNodeArray = [];
      state.selectedList.forEach((item) => {
        newCheckedNodeArray.push(item[props.nodeKey]);
      });
      treeRef.value.setCheckedKeys(newCheckedNodeArray);
      state.sourceList = state.sourceList.filter(
        (item) => !state.checkList.includes(item[props.nodeKey])
      );
      state.checkList = [];
      state.checked2 = false;
      isIndeterminate.value = false;
    };
    // 移入数据
    const addData = () => {
      const nodes = treeRef.value.getCheckedNodes(true, false);
      const cloneDate = _.cloneDeep(nodes);
      const cloneObj = {};
      // 去重
      cloneDate.forEach((item) => {
        cloneObj[item[props.nodeKey]] = item;
      });
      state.sourceList.forEach((item) => {
        if (cloneObj[item[props.nodeKey]]) {
          Reflect.deleteProperty(cloneObj, item[props.nodeKey]);
        }
      });
      const checkedList = Object.values(cloneObj).filter((item) => {
        return Reflect.has(item, props.checkedKey);
      });
      if (props.showEquipmentType) {
        checkedList.forEach((item) => {
          if (!item.cameraInOutType) item.cameraInOutType = "0";
        });
      }
      state.selectedList = [...state.selectedList, ...checkedList];
      state.sourceList = [...state.sourceList, ...checkedList];
    };
    // 已添加的数据列表选中状态变化时触发
    const handleCheckedCitiesChange = (value) => {
      const checkedCount = value.length;
      state.checked2 = checkedCount === state.sourceList.length;
      isIndeterminate.value =
        checkedCount > 0 && checkedCount < state.sourceList.length;
    };
    //  已添加的数据列表的全选状态变化时触发
    const handleCheckAllChange = (val) => {
      let checkList = [];
      if (val) {
        checkList = state.selectedList.map((item) => item[props.nodeKey]);
      }
      state.checkList = checkList;
      isIndeterminate.value = false;
    };
    //  树的全选状态变化时触发
    const handleTreeCheckAllChange = (val) => {
      if (val) {
        treeRef.value.setCheckedNodes(props.data);
      } else {
        treeRef.value.setCheckedNodes([]);
      }
    };
    // 获取数据字典
    const queryMenuType = async () => {
      const res = await getDict("camera_inout_type");
      state.selectTypeList = res.dict;
    };
    if (props.showEquipmentType) {
      queryMenuType();
    }
    onMounted(() => {
      addData();
      if (props.areaCameraArry.length > 0) {
        handleSetChecked();
        addData();
      }
      handleCheckChange();
    });
    return {
      ...refData,
      treeRef,
      filterNode,
      handleCheckChange,
      handleCheckedCitiesChange,
      handleCheckAllChange,
      handleTreeCheckAllChange,
      isIndeterminate,
      addData,
      delData,
      handleNodeClick,
    };
  },
});
</script>
<style lang="scss" scoped>
.HTransfer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  .h-transfer-panel {
    flex: 1;
    .card-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 18px;
        font-weight: 600;
      }
    }
    :deep(.el-card__header) {
      padding: 0 10px;
    }
    .h-transfer-panel__body {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;

      .h-transfer-panel__list {
        flex: 1;
        overflow: auto;
        margin-top: 5px;
        .h-transfer-panel__group {
          display: flex;
          flex-direction: column;
          .selectedList {
            @include flex-row-sb-c;
            padding: 0 8px 0 0;
          }
          // :deep(.el-checkbox__label) {
          //   width: 100%;
          //   @include flex-row-sb-c;
          // }
          // :deep(.el-checkbox:last-of-type) {
          //   margin-right: 30px;
          // }
        }
      }
    }
  }
  .h-transfer__buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    :deep(.el-button) {
      margin: 10px 0;
    }
  }
}
</style>
